module.exports = __webpack_public_path__ + "static/img/natalis.582eefa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/natalis.png
// module id = bI07
// module chunks = 0